<style>

#saving_message {
  font-size: 12px;
}

.details_dialog {
    width: 60%;
}

.declaration_add_button {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 30%;
    align-self: center;
}



</style>

<template>
  <v-dialog v-model="show" class='details_dialog'>
    <v-card>
      <v-card-title>
        N. <b>{{ selected_item.number }}</b> del <b>{{ selected_item.creation_date }}</b>
        <v-spacer></v-spacer>
        <v-tooltip text="Modifica">
          <template v-slot:activator="{ props }">
            <v-btn 
              @click="switchEdit()"
              variant="tonal"
              :icon="editable ? 'mdi-check' : 'mdi-pencil'"
              v-bind="props"
              :disabled="saving"
            ></v-btn>
            <span v-if="saving" id="saving_message" class="text-primary ml-2">Salvataggio in corso...</span>
          </template>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="formValues.status"
          :items="['Aperta', 'Chiusa']"
          :label="(headers.find(h => h.value === 'status') || headers_details_additional.find(h => h.value === 'status'))?.title"
          :readonly="!editable"
          persistent-placeholder
          :value="formValues.status"    
        ></v-select>
        <v-select
            v-model="formValues.type.name"
            :items="type_options.map(t => t.value)"
            :label="(headers.find(h => h.value === 'type') || headers_details_additional.find(h => h.value === 'type'))?.title"
            dense
            :readonly="!editable"            
            persistent-placeholder
            :value="formValues.type.name"
        >
        </v-select>
        <v-select
            v-model="formValues.error_type.name"
            :items="error_type_options.map(t => t.value)"
            :label="(headers.find(h => h.value === 'error_type') || headers_details_additional.find(h => h.value === 'error_type'))?.title"
            dense
            :readonly="!editable"
            persistent-placeholder
            :value="formValues.error_type.name"
        >
        </v-select>
        <v-text-field 
            v-model="formValues.protocol"
            :label="(headers.find(header => header.value === 'protocol') || headers_details_additional.find(h => h.value === 'protocol'))?.title"
            dense
            :readonly="!editable"
            persistent-placeholder
            :value="formValues.protocol"
        ></v-text-field>
        <v-date-input 
            v-model="formValues.notification_date"
            :label="(headers.find(h => h.value === 'notification_date') || headers_details_additional.find(h => h.value === 'notification_date'))?.title"
            dense
            :readonly="!editable"       
            persistent-placeholder
            :value="formatDateToLocaleString(formValues.notification_date)"
        ></v-date-input>
        <v-date-input 
            v-model="formValues.expiration_date"
            :label="(headers.find(h => h.value === 'expiration_date') || headers_details_additional.find(h => h.value === 'expiration_date'))?.title"
            dense
            :readonly="!editable"
            persistent-placeholder
            display-format="keyboardDate"
            :value="formatDateToLocaleString(formValues.expiration_date)"
            input-format="dd/mm/yyyy"
        ></v-date-input>
        <v-select
            v-model="formValues.in_charge_of"
            :items="['Azienda', 'Cliente']"
            :label="(headers.find(h => h.value === 'in_charge_of') || headers_details_additional.find(h => h.value === 'in_charge_of'))?.title"
            dense
            :readonly="!editable"
            persistent-placeholder
            :value="formValues.in_charge_of"    
        >
        </v-select>
        <v-select
            v-model="formValues.representation"
            :items="['Diretta', 'Indiretta']"
            :label="(headers.find(h => h.value === 'representation') || headers_details_additional.find(h => h.value === 'representation'))?.title"
            dense
            :readonly="!editable"
            persistent-placeholder
            :value="formValues.representation"    
        >
        </v-select>
        <v-select
            v-model="formValues.invoiced"
            :items="['Si', 'No']"
            :label="(headers.find(h => h.value === 'invoiced') || headers_details_additional.find(h => h.value === 'invoiced'))?.title"
            dense
            :readonly="!editable"
            persistent-placeholder
            :value="formValues.invoiced"    
        >
        </v-select>
        <v-textarea
            v-model="formValues.notes"
            :label="(headers.find(h => h.value === 'notes') || headers_details_additional.find(h => h.value === 'notes'))?.title"
            variant="outlined"
            rows="3"
            dense
            :readonly="!editable"
            persistent-placeholder
            :value="formValues.notes"
        ></v-textarea> 

        <v-card v-if="formValues.declarations && formValues.declarations.length > 0">
          <v-card-title>Dichiarazioni</v-card-title>
          <v-data-table
          :items="formValues.declarations"
          :items-per-page-text="'Elementi per pagina: '"
          :page-text="`Da {0} a {1} di {2} elementi`">
              <thead>
                  <tr>
                  <th v-for="header in headers_declarations" :key="header">
                      <b>{{ header.title }}</b>
                  </th>
                  <th></th> <!-- aggiungi una colonna per il pulsante di eliminazione -->
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="declaration in formValues.declarations" :key="declaration.id">
                  <td v-for="header in headers_declarations" :key="header">{{ declaration[header.value] || '-' }}</td>
                  <td>
                      <v-btn v-if="editable" @click="removeDeclaration(declaration.mrn)" icon size="x-small" color="error">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                  </td>
                  </tr>
              </tbody>
          </v-data-table>
        </v-card>

        <v-btn v-if="editable" @click="addDeclaration" class="declaration_add_button">
          Aggiungi dichiarazione
        </v-btn>

        <v-dialog v-model="dialogAddDeclaration" max-width="500">
          <v-card>
            <v-card-title>Aggiungi dichiarazione</v-card-title>
            <v-card-text>
              <v-text-field v-model="newMrn" label="MRN"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="cancelAddDeclaration">Annulla</v-btn>
              <v-btn @click="saveAddDeclaration">Salva</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-card-text>
      
      <v-card-actions>
        <v-tooltip text="Elimina">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" class="action_button" variant="tonal" icon="mdi-delete" color="error" @click="deleteLitigation(selected_item.id)"></v-btn>
          </template>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog> 
  <confirmDeleteDialog ref="confirmDeleteDialog" @delete-completed="$emit('delete-completed')"/>
  <snackbarTemplate ref="snackbar" />
</template>

  <script>
    import axios from 'axios';
    import _ from 'lodash';
    import snackbarTemplate from './Snackbar.vue'
    import confirmDeleteDialog from './ConfirmDeleteDialog.vue';
    //import confirmCancelModificationDialog from './ConfirmCancelModificationDialog.vue';

    export default {
        name: 'detailsDialog',
        emits: ['delete-completed', 'update-completed'],
        components: {
            snackbarTemplate,
            confirmDeleteDialog,
            //confirmCancelModificationDialog
        },
        data() {
            return {
                show: false,
                selected_item: {},
                editable: false,
                headers: [],
                headers_details_additional: [
                    { title: 'Dichiarazioni', value: 'declarations', sortable: false},
                    { title: 'Rappresentanza', value: 'representation', sortable: false},
                ],
                headers_declarations: [
                    { title: 'MRN', value: 'mrn'},
                    { title: 'Data Registrazione', value: 'registration_date'},
                    { title: 'Rettifica', value: 'is_revision'},
                    { title: 'Tipo', value: 'category_code'},
                    { title: 'Pratica', value: 'internal_reference'},
                    { title: 'Sezione Doganale', value: 'customs_office_code'},
                    { title: 'Utente', value: 'username'},
                ],
                formValues: {},
                newMrn: '',
                newMrnList: [],
                dialogAddDeclaration: false,
                saving: false
            } 
        },
        props: {
            type_options: Array,
            error_type_options: Array,
        },
        methods: {
          
          hasChanges() {
            return JSON.stringify(this.formValues) !== JSON.stringify(this.selected_item);
          },
          formatDateBeforeUpdate(date) {
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
          formattedDate(date) {
            if (date) {
              return date.split("/").reverse().join("-");
            } else {
              return null;
            }
          },
          formatDateToLocaleString(date) {
            if (date) {
              if (date instanceof Date) {
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                return `${day}/${month}/${year}`;
              } else {
                  return date.split("-").reverse().join("/");
              }
            } else {
              return null;
            }
          },
          prepareForm() {
            this.formValues = _.cloneDeep(this.selected_item);
            this.formValues.notification_date = this.formattedDate(this.selected_item.notification_date);
            this.formValues.expiration_date = this.formattedDate(this.selected_item.expiration_date);
          },
          saveChanges() {
            this.saving = true;
            this.editable = false;

            const updatedFormValues = {
              status: this.formValues.status,
              protocol: this.formValues.protocol,
              notification_date: this.formValues.notification_date instanceof Date ? 
                this.formatDateBeforeUpdate(this.formValues.notification_date) : this.formattedDate(this.formValues.notification_date),
              expiration_date: this.formValues.expiration_date instanceof Date ? 
                this.formatDateBeforeUpdate(this.formValues.expiration_date) : this.formattedDate(this.formValues.expiration_date),
              in_charge_of: this.formValues.in_charge_of,
              representation: this.formValues.representation,
              type_id: this.type_options.find(t => t.value === this.formValues.type.name)?.key,
              error_type_id: this.error_type_options.find(t => t.value === this.formValues.error_type.name)?.key,
              notes: this.formValues.notes,
              mrn_list: (this.formValues.declarations ? this.formValues.declarations.map(declaration => declaration.mrn) : []).concat(this.newMrnList),
            };

            axios.patch('/api/litigations/' + this.formValues.id + '/', updatedFormValues)
            .then(response => {
              console.log('Richiesta inviata:', axios.defaults.headers.common);
              console.log('Response ricevuta:', response);
              this.$emit('update-completed');         
              this.selected_item = _.cloneDeep(this.formValues);
              this.saving = false;
            })
            .catch(error => {
              console.error(error)
              this.saving = false;
              this.$refs.snackbar.snackbar_message = error.request.responseText;
              this.$refs.snackbar.snackbar_style = 'error';
              this.$refs.snackbar.show = true;
            })
            .finally(() => {});
          },
          switchEdit() {
            if (this.editable) {
              if (this.hasChanges()) {
                this.saveChanges();
              } else {
                this.editable = false
              }
            } else {
              this.editable = true
              this.prepareForm();
            }

            if (!this.editable) {
              this.show = false
            }
             
          },
          deleteLitigation(id) {
          this.$refs.confirmDeleteDialog.litigation_id = id;
          this.$refs.confirmDeleteDialog.litigation_number = this.selected_item.number;
          this.show = false;
          this.$refs.confirmDeleteDialog.show = true;
          },
          removeDeclaration(mrn) {
            this.formValues.declarations = this.formValues.declarations.filter(declaration => declaration.mrn !== mrn);
          },
          addDeclaration() {
            this.dialogAddDeclaration = true
          },
          cancelAddDeclaration() {
            this.dialogAddDeclaration = false
            this.newMrn = ''
          },
          saveAddDeclaration() {
            if (this.formValues.declarations && this.formValues.declarations.findIndex(declaration => declaration.mrn === this.newMrn) !== -1) {
              alert('MRN ' + this.newMrn + ' già presente')
              return
            }
            if (this.formValues.declarations) {
              this.formValues.declarations.push({ 
                mrn: this.newMrn,
                registration_date: null,
                category_code: null,
                internal_reference: null,
                customs_office_code: null,
                origin_id: null,
                origin_system: null,
                username: null
              })
            } else {
              this.formValues.declarations = [{ 
                mrn: this.newMrn,
                registration_date: null,
                category_code: null,
                internal_reference: null,
                customs_office_code: null,
                origin_id: null,
                origin_system: null,
                username: null
              }]
            }
            this.dialogAddDeclaration = false
            this.newMrn = ''
          }
        },
        watch:{
          show: function(newValue){
            if(!newValue){
              this.editable = false
            }
          }
        }
    }      
</script>